import { render } from "./DonationForm.vue?vue&type=template&id=25d75ba5&scoped=true"
const script = {}

import "./DonationForm.vue?vue&type=style&index=0&id=25d75ba5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d75ba5"]])

export default __exports__